<div class="w-100 pt-5">
    <div class="buttons-wrapper w-100 px-3 d-flex align-items-center justify-content-between">
        <div class="switch-wrapper col-xl-3 col-md-6 col-sm-12 col-xs-12 d-flex align-items-center">
            <div id="firstFilter" class="filter-switch mt-1">
                <input id="option1" name="options" type="radio" value="1" [checked]="viewAttuale === 1"
                    (change)="switchSezione(1)" />
                <label class="option mb-0" for="option1">Bollettini</label>

                <input id="option2" name="options" type="radio" value="2" [checked]="viewAttuale === 2"
                    (change)="switchSezione(2)" />
                <label class="option mb-0" for="option2">Archivi</label>

                <span class="background"></span>
            </div>
        </div>
        <button class="col-xl-3 col-md-6 col-sm-12 col-xs-12 bottone-guida" (click)="openModal(theModalGuida)">
            <i class="fas fa-question-circle"></i> Guida alla consultazione
        </button>
    </div>
    <!-- Previsioni  -->
    <div class="section p-2" *ngIf="viewAttuale==1">
        <previsioni></previsioni>
    </div>
    <!-- Archivio  -->
    <div class="section p-2 nb-theme-default d-flex flex-column align-items-center" *ngIf="viewAttuale==2">
        <div class="p-1" style="width: 80%;">
            <bollettini-meteo></bollettini-meteo>
        </div>
        <div class="p-1" style="width: 80%;">
            <archivio-allerta-massima></archivio-allerta-massima>
        </div>
    </div>
    <div class="container banner-container mb-4 w-100">
        <div class="banner-title"><i class="fa-solid fa-triangle-exclamation mr-1" style="color: #FFD43B;"></i>Avvertenza</div>
        <p class="banner-text">
            I bollettini e gli avvisi pubblicati nel sito sono diffusi ufficialmente, a ogni effetto di legge, dalla “Sala Operativa Regionale Unificata”, struttura tecnica della protezione civile responsabile dell’adozione delle fasi di allerta regionali e dell’attivazione della risposta operativa regionale di protezione civile, che ne integra i contenuti mediante specifiche avvertenze di protezione civile e/o indicazioni per l’attivazione, se del caso, dei sistemi comunali e territoriali di protezione civile
        </p>
        <p class="banner-text">
        I bollettini e gli avvisi pubblicati nel sito del Centro Funzionale, quindi, sono da considerarsi atti tecnico-scientifici, di natura endoprocedimentale, da sottoporre a validazione e recepimento negli atti amministrativi, a valenza esterna e con connotazione di provvedimento finale, adottati dalla SORU in esito all’istruttoria dei procedimenti definiti nel vigente sistema di allertamento regionale per il rischio idrogeologico e idraulico a fini di protezione civile.</p>
        
    </div>
</div>

<!-- guida -->
<ng-template #theModalGuida let-modal let-c="close" let-d="dismiss">
    <div class="border-bottom p-3 d-flex justify-content-between align-items-center">
        <span class="h4 m-0" style="float: left; margin-top: 10px;">Guida alla consultazione</span>
        <button type="button" class="close" (click)="closeSingleModal(modal)">
            <span aria-hidden="true" style="font-size: 3rem; line-height: 1;">&times;</span>
        </button>
    </div>
    <div class="modal-body border-bottom">
        <div class="w-100 border-bottom py-2">
            <ta-livAllertaLegenda></ta-livAllertaLegenda>
        </div>
        <div class="w-100 py-2">
            <guida-allerta></guida-allerta>
        </div>
    </div>
    <div class=" pt-3 modal-footer d-flex justify-content-end">
        <button class="btn btn-danger" (click)="closeSingleModal(modal)">
            <span class="h5">Chiudi</span>
        </button>
    </div>
</ng-template>